module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionWlcj.4f07fa5e.png";